























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class FoodMenu extends Vue {
  post = 0;
  cols = 2;
  width = null;
  type = "Special";

  numberOfColumns() {
    //console.log(window.innerWidth)
    if (window.innerWidth > 576) {
      this.cols = 2;
    } else {
      this.cols = 1;
    }
  }

  created() {
    window.addEventListener("resize", this.numberOfColumns);
    this.numberOfColumns();
  }

  get columns() {
    let columns = [];
    let mid = Math.ceil(this.filteredList.length / this.cols);
    for (let col = 0; col < this.cols; col++) {
      columns.push(this.filteredList.slice(col * mid, col * mid + mid));
    }
    return columns;
  }

  get filteredList() {
    const listFood = this.$store.state.foodMenu;
    return listFood.filter((post: any) => {
      return post.type === this.type;
    });
  }
}
